import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence  } from 'framer-motion';
import SpinnerRing from './components/SpinnerRing';
import { projectMeta } from './projects/data';
import { toCdn } from './utils/cdn';

import Work from './pages/Work';
import About from './pages/About';

function App() {

  const location = useLocation();

  // Preload screen textures once at app start
  React.useEffect(() => {
    try {
      Object.values(projectMeta).forEach((m) => {
        if (!m || !m.screenImage) return;
        const img = new Image();
        img.decoding = 'async';
        img.loading = 'eager';
        img.src = m.screenImage;
      });
    } catch(_) {}
  }, []);

  // Proactively preload top posters for SwiftUI and Archive to improve first paint
  React.useEffect(() => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const links = [];
    try {
      const swiftNames = ['finderCam','glassText','magnify','movies','chatheads','filmFinder','color','dots'];
      swiftNames.forEach((name) => {
        const l = document.createElement('link');
        l.rel = 'preload';
        l.as = 'image';
        l.href = toCdn(`/images/projects/swiftui/${name}_poster.webp`);
        try { l.fetchPriority = 'high'; } catch(_) {}
        head.appendChild(l); links.push(l);
      });
      const archiveFirst = ['reactButtons','particles','shader1','shader2','walk','burger'];
      archiveFirst.forEach((name) => {
        const l = document.createElement('link');
        l.rel = 'preload';
        l.as = 'image';
        l.href = toCdn(`/images/projects/archive/${name}.webp`);
        try { l.fetchPriority = 'high'; } catch(_) {}
        head.appendChild(l); links.push(l);
      });
    } catch(_) {}
    return () => { links.forEach((l) => { try { head.removeChild(l); } catch(_) {} }); };
  }, []);

  return (
    <>
      <Navigation />

          <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Work waitForReady />} />
            <Route path="/work" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<About waitForReady />} />
          </Routes>
          </AnimatePresence>

      <GlobalSpinner />

    </>
  );
}

export default App;

function GlobalSpinner(){
  const location = useLocation();
  const [visible, setVisible] = React.useState(location.pathname === '/');
  React.useEffect(() => {
    const onVis = (e) => {
      try { setVisible(!!e.detail?.visible); } catch(_) {}
    };
    window.addEventListener('transitionSpinnerVisible', onVis);
    return () => window.removeEventListener('transitionSpinnerVisible', onVis);
  }, []);
  return (
    <div
      className="transition-spinner"
      style={{ opacity: visible ? 1 : 0, visibility: visible ? 'visible' : 'hidden' }}
      aria-hidden={visible ? 'false' : 'true'}
    >
      <SpinnerRing text="LOADING • " repeats={6} size={120} color={'var(--color-accent-green)'} fontSize={11} />
    </div>
  );
}
